<mat-card appearance="outlined">
  <mat-card-header fxLayout="row" fxLayoutAlign="space-between center">
    <mat-card-title>Alerts</mat-card-title>

    @if (!viewOnly) {
      <button mat-fab color="primary" (click)="onAddAlertClicked()" matTooltip="Add Alert" class="addButton" telemetry="Submission-AddAlert">
        <mat-icon>add</mat-icon>
      </button>
    }
  </mat-card-header>

  <mat-card-content [formGroup]="alertListForm" fxLayout="column" fxLayoutAlign="space-between stretch">
    @if (!isLoaded) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    @if (!hasAlerts) {
      <div fxLayoutAlign="center center">
        <mat-icon>info</mat-icon>
        <strong>No alerts</strong>
      </div>
    }

    @if (hasAlerts) {
      <div fxLayout="column">
        @for (alertCard of alertCards; track alertCard) {
          @if (!isDelete(alertCard)) {
            <alert formArrayName="rows" [model]="alertCard" [viewOnly]="viewOnly" (delete)="onDelete($event)">
            </alert>
          }
        }
      </div>
    }
  </mat-card-content>

  <mat-card-actions align="end" class="contact-manager-actions">
    @if (viewOnly) {
      <button mat-raised-button color="primary" (click)="onClose()" telemetry="Submission-AlertClose">
        Close
      </button>
    }

    @if (!viewOnly) {
      <button mat-button (click)="onClose()" telemetry="Submission-AlertCancel">
        Cancel
      </button>
    }

    @if (!viewOnly) {
      <button mat-raised-button color="primary" [disabled]="alertListForm.invalid" (click)="save()" telemetry="Submission-AlertSave">
        Save
      </button>
    }
  </mat-card-actions>
</mat-card>